import React, { PureComponent } from 'react';
import Link from '@material-ui/core/Link';
import CardHeader from '@material-ui/core/CardHeader';
import FormControl from '@material-ui/core/FormControl';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { AppButton } from '../../packages/AppButton';
import FormGroupComponent from '../../packages/AppFormGroup';
import AppAdapterLink from '../../packages/AppAdapterLink';
import FormFields from './FormField.json';
import { APP_CONSTANTS } from '../../constants';
import { debounced, validateForm } from '../../utils';
import AppBasePageCard from '../../packages/AppBasePageCard';
import { resetUserPassword } from '../../modules/User/actions';

class ResetPasswordPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      heading: 'Reset Password!',
      formValue: { email: '' },
      fieldError: {},
      requiredFields: ['email'],
      validForm: false,
      loading: false,
    };
    this.doFormValidation = debounced(400, () => {
      this.setState((prevState) => ({
        validForm: validateForm({ ...prevState }),
      }));
    });
  }

  componentDidMount() {
    const { isAuthenticated } = this.props;
    if (isAuthenticated) {
      this.props.history.push(APP_CONSTANTS.APP_ROUTE_URLS.DASHBOARD);
    }
  }

  handleChange = ({ name, value, error }) => {
    this.setState(
      (prevState) => ({
        ...prevState,
        formValue: {
          ...prevState.formValue,
          [name]: value,
        },
        fieldError: {
          ...prevState.fieldError,
          [name]: error,
        },
      }),
      () => {
        this.doFormValidation();
      },
    );
  };

  formSubmitHandler = () => {
    this.setState({ loading: true, validForm: false });
    const {
      formValue: { email },
    } = this.state;

    this.props
      .resetUserPassword({ email })
      .then(() => {
        this.props.history.push(APP_CONSTANTS.BASE_ROUTE_URLS.LOGIN);
      })
      .catch(() => {
        this.setState({ loading: false, validForm: true });
      });
  };

  render() {
    const { heading, validForm, loading } = this.state;
    return (
      <AppBasePageCard md={3}>
        <CardHeader subheader={heading} className="card-heading" />
        <CardContent>
          <form
            noValidate
            autoComplete="off"
            name="signInForm"
            className="form-container"
          >
            <FormGroupComponent
              handleChange={this.handleChange}
              formFields={FormFields[0]}
              values={{ email: '' }}
            />
            <FormControl fullWidth margin="normal">
              <AppButton
                fullWidth
                variant="contained"
                color="primary"
                disabled={!validForm}
                label="Reset"
                loading={loading}
                loaderSize={24}
                handleClick={this.formSubmitHandler}
              />
            </FormControl>
          </form>
          <Typography variant="subtitle1" align="center">
            Not an AidQuest member?{' '}
            <Link
              component={AppAdapterLink}
              to={APP_CONSTANTS.BASE_ROUTE_URLS.BASIC_REGISTER}
              color="primary"
            >
              Sign up here.
            </Link>
          </Typography>
          <Typography variant="subtitle1" align="center">
            <Link
              component={AppAdapterLink}
              to={APP_CONSTANTS.BASE_ROUTE_URLS.LOGIN}
              color="primary"
            >
              Back to Login
            </Link>
          </Typography>
        </CardContent>
      </AppBasePageCard>
    );
  }
}
const mapStateToProps = (state) => ({
  isAuthenticated: state.Session.isAuthenticated,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      resetUserPassword,
    },
    dispatch,
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage),
);
